import { validate, } from '../validator.node.js';
const configRequestSchema = {
    type: 'object',
    additionalProperties: false,
    properties: {
        language: {
            type: 'string',
        },
    },
};
export function configRequestValidator(props) {
    return validate(configRequestSchema, props);
}
const configResponseSchema = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            const: 'ok',
        },
        languages: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    iso: { type: 'string' },
                    display: { type: 'string' },
                },
                required: ['iso', 'display'],
                additionalProperties: false,
            },
        },
    },
    required: [
        'status',
    ],
};
export function configResponseValidate(props) {
    return validate(configResponseSchema, props);
}
export async function commonConfig(baseUrl, props) {
    const result = await fetch(`${baseUrl}/api/common/config`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    if (result.status === 200) {
        return await result.json();
    }
    if (result.status === 400) {
        // TODO: validate
        return await result.json();
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
//# sourceMappingURL=CommonApi.js.map